import { Component } from '@angular/core';
import { StorageService } from '../../../providers/service/storageservice';
import { WebService } from '../../../providers/service/webservice';
import { APPLYLIST} from '../../../providers/config/serviceurl';
import { LoadingController,App} from 'ionic-angular';
import { AppState } from '../../../app/app.global';
import { LoginPage } from '../../login/login/login';
import { BrowserPage } from '../../comm/browser/browser';
import { NewsListPage } from '../news/list/list';
import { SearchPage } from '../search/search';
import { NewsDetail } from '../news/detail/detail';
import { AddressBookList } from '../../application/dailyoffice/addressbook/list/addressbooklist';
import { CardQueryPage } from '../../application/life/card/cardquery';
import { BooksOverview } from '../../application/life/books/overview/mybooks';
import { HelpCenter } from '../../application/dailyoffice/helpcenter/overview/helpcenter';
import { UnifiedAddressBookList } from '../../application/dailyoffice/unifiedaddressbook/list/unifiedaddressbooklist';
import { PersonalInfo } from '../../application/teaching/personalinfo/personalinfo';
import { ClassSchedule } from '../../application/teaching/classschedule/classschedule';
import { ElectiveResult } from '../../application/teaching/elective/electiveresult';
import { ScoreQueryPage } from '../../application/teaching/score/scorequery';
import { FreeClassroom } from '../../application/teaching/freeclassroom/freeclassroom';
import { ProjectList } from '../../application/research/project/list/projectlist';
import { ProjectFundingList } from '../../application/research/profunding/list/list';
import { ThesisList } from '../../application/research/thesis/list/list';
import { ProductionList } from '../../application/research/production/list/list';
import { CopyrightList } from '../../application/research/copyright/list/list';
import { SalaryInquiry } from '../../application/finance/salary/salaryinquiry';
import { ReportList } from '../../application/research/report/list/list';
import { PrizeList } from '../../application/research/prize/list/list';
import { IdentificationList } from '../../application/research/identification/list/list';
import { PatentList } from '../../application/research/patent/list/list';
import { AppointInfo } from '../../application/personnel/appoint/appointinfo/appointinfo';
import { FRZSQ} from '../../../providers/config/serviceurl';
import { YZSQ} from '../../../providers/config/serviceurl';
import { XZSQSQ} from '../../../providers/config/serviceurl';
import { SSKTSQ} from '../../../providers/config/serviceurl';
import { JSQKDRWSQ} from '../../../providers/config/serviceurl';
@Component({
  selector: 'home-page',
  templateUrl: 'myservices.html'
})
export class MyServicesPage {
    editClass:string="";
    iconFlag:boolean=false;
    editStatus:string="编辑";
    homeApply:any=[];
    studentApply:any=[];
    publicApply:any=[];
    user:any =null;
    public loading:any;
    homeShowFlag:boolean=false;
    studentShowFlag:boolean=false;
    publicShowFlag:boolean=false;
    delData:any= [];
    addData:any = [];
    keyword:string="";
    applysList = {};//应用分类  列表
    currentUser:any;
    constructor(public global: AppState,private loadCtrl:LoadingController,public appCtrl: App,private webService:WebService) {
    	this.user = StorageService.getObj('currentUser');
      let userId = "";
      if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
      	/*StorageService.remove('currentUser');
      	this.appCtrl.getRootNav().push(LoginPage);*/
      }else{
      	userId = this.user.userId;
      }
      this.loading = this.loadCtrl.create({
      	content: '加载中...',
      });
     // this.loading.present();
     // this.getServiceList(userId);
    }
    

    getServiceList(userId:any){
    	let params = {"userId":userId};
    	this.webService.post(APPLYLIST,params,'服务列表').then(anyObj =>this.handleServiceList(anyObj));
    	/*let testData = {
        "homeApply":[
            {
              "id":"1",
              "name":"通讯录",
              "applyIcon":"assets/acco/me-1.png",
              "type":"1",
             },
            {
              "id":"2",
              "name":"校车查询",
              "applyIcon":"assets/acco/me-2.png",
              "type":"1",
             }
           ],
           "studentApply":[
             {
              "id":"8",
              "name":"嘿嘿",
              "applyIcon":"assets/acco/me-3.png",
              "type":"2",
             }
          ],
        "publicApply":[
             {
              "id":"5",
              "name":"哈哈",
              "applyIcon":"assets/acco/me-4.png",
              "type":"3",
             }
          ]
        };
        this.handleServiceList(testData);*/
    }
    handleServiceList(obj:any){
    	if(obj){
    		this.homeApply = obj.homeApply;
    		this.studentApply = obj.studentApply;
    		this.publicApply = obj.publicApply;
    		if(this.homeApply.length>0){
    			this.homeShowFlag = true;
    		}
    		if(this.studentApply.length>0)
    		{
    			this.studentShowFlag=true;
    		}
        if(this.publicApply.length>0){
        	this.publicShowFlag=true;
        }
    	}
    	this.loading.dismiss();//加载动画结束

    }
    editServices($event:any,editStatus:any){
    	if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
    		StorageService.remove('currentUser');
        this.appCtrl.getRootNav().push(LoginPage);
    	}
    	if(editStatus == "编辑"){
    		this.editClass="services-edit";
    		this.iconFlag=true;
    		this.editStatus = "完成"
    	}else if(editStatus == "完成"){
    		this.editClass="";
    		this.iconFlag=false;
    		this.editStatus="编辑";
    		//let params={"userId":this.user.userid,"applyList":addData};
    		//this.webService.post(APPLYDELE,params,'服务删除').then(anyObj =>{});
    		//let params={"userId":this.user.userid,"applyList":delData};
    		//this.webService.post(APPLYADD,params,'服务添加').then(anyObj =>{});

    	}
    }
    removeService($event:any,item:any){
    	  this.delData.push(item.id);
    	  let aindex = this.addData.indexOf(item.id);
    	  if(aindex>=0){
    		  this.addData.splice(aindex,1);
       	}
    		let index = this.homeApply.indexOf(item);
        this.homeApply.splice(index,1);
        if(item.type == "2"){
        	this.studentApply.push(item);
        	if(this.studentApply.length >0){
        	  this.studentShowFlag = true;
        	}
        }else if(item.type == "3"){
        	this.publicApply.push(item);
        	if(this.publicApply.length >0){
        	  this.publicShowFlag = true;
        	}
        }
    }
    addService(belongs:string,item:any){
    	this.addData.push(item.id);
    	let index = this.delData.indexOf(item.id);
    	if(index>=0){
    		this.delData.splice(index,1);
    	}
    	if(belongs == 'student'){
    		let index = this.studentApply.indexOf(item);
        this.studentApply.splice(index,1);
        this.homeApply.push(item);
        if(this.studentApply.length <=0){
        	this.studentShowFlag = false;
        }
    	}else if(belongs == 'public'){
    		let index = this.publicApply.indexOf(item);
        this.publicApply.splice(index,1);
        this.homeApply.push(item);
        if(this.publicApply.length <=0){
        	this.publicShowFlag=false;
        }
    	}
    }
    search(keyword:string){
	  	if(keyword == "" || keyword == undefined){
	  		return;
	  	}else{
	  			keyword = keyword.replace(/(^\s+)|(\s+$)/g,"").replace(/\s/g,"");//去除前后空格和中间的空格
	  	}
	  	this.loading = this.loadCtrl.create({
      	content: '加载中...',
      });
      this.loading.present();
	  	//let params = {"keyword":keyword};
	   	//this.httpService.get(url,null).then(anyObj =>this.handleSearchData(anyObj));
	   	//this.webService.post(APPLYSEARCH,params,'服务搜索').then(anyObj =>{});
	   	let testData = {
        "homeApply":[
            {
              "id":"1",
              "name":"通讯录",
              "applyIcon":"assets/acco/me-1.png",
              "type":"1",
             },
            {
              "id":"2",
              "name":"校车查询",
              "applyIcon":"assets/acco/me-2.png",
              "type":"1",
             }
           ],
           "studentApply":[
             {
              "id":"8",
              "name":"嘿嘿",
              "applyIcon":"assets/acco/me-3.png",
              "type":"2",
             }
          ],
        "publicApply":[
             {
              "id":"5",
              "name":"哈哈",
              "applyIcon":"assets/acco/me-4.png",
              "type":"3",
             },
             {
              "id":"5",
              "name":"溜溜",
              "applyIcon":"assets/acco/me-5.png",
              "type":"3",
             }
          ]
        };
	    this.handleSearchData(testData);
    }
    handleSearchData(obj:any){
    	if(obj){
    	  this.homeApply = obj.homeApply;
    		this.studentApply = obj.studentApply;
    		this.publicApply = obj.publicApply;
    		if(this.homeApply.length>0){
    			this.homeShowFlag = true;
    		}
    		if(this.studentApply.length>0)
    		{
    			this.studentShowFlag=true;
    		}
        if(this.publicApply.length>0){
        	this.publicShowFlag=true;
        }
    	}
      this.loading.dismiss();//加载动画结束
    }
    
    openNewsList(){
  	this.appCtrl.getRootNav().push(NewsListPage);
  }
   goToAddressBook(){
  	this.appCtrl.getRootNav().push(AddressBookList);
   }

   goToCardPage(){
   	this.appCtrl.getRootNav().push(CardQueryPage);
   }

   goToMyBooks(){
   	 this.appCtrl.getRootNav().push(BooksOverview);
   }

   goToHelpCenter(){
   	 this.appCtrl.getRootNav().push(HelpCenter);
   }

   goToUnifiedAddressBook(){
   	 this.appCtrl.getRootNav().push(UnifiedAddressBookList);
   }

   goToPersonalInfo(){
   	 this.appCtrl.getRootNav().push(PersonalInfo);
   }

   goToClassSchedule(){
   	  this.appCtrl.getRootNav().push(ClassSchedule);
   }

   goToElectiveResult(){
   	  this.appCtrl.getRootNav().push(ElectiveResult);
   }

   goToScorePage(){
   	  this.appCtrl.getRootNav().push(ScoreQueryPage);
   }

   goToFreeClassroomPage(){
    	this.appCtrl.getRootNav().push(FreeClassroom);
   }

   goToResearchPage(){
   	this.appCtrl.getRootNav().push(ProjectList);
   }

   goToProFundingPage(){
   	this.appCtrl.getRootNav().push(ProjectFundingList);
   }

	 goToThesePage(){
	 	this.appCtrl.getRootNav().push(ThesisList);
	 }

	 goToProductionPage(){
	 	this.appCtrl.getRootNav().push(ProductionList);
	 }

	 goToCopyrightPage(){
	 	this.appCtrl.getRootNav().push(CopyrightList);
	 }

	 goToSalaryInquiryPage(){
	 	this.appCtrl.getRootNav().push(SalaryInquiry);
	 }

	 goToReoprtPage(){
	 	this.appCtrl.getRootNav().push(ReportList);
	 }

	 goToPrizePage(){
	 	this.appCtrl.getRootNav().push(PrizeList);
	 }

	 goToIdentificationPage(){
	 	this.appCtrl.getRootNav().push(IdentificationList);
	 }

	 goToPatentPage(){
	 	this.appCtrl.getRootNav().push(PatentList);
	 }

	 goToAppointPage(){
	 	this.appCtrl.getRootNav().push(AppointInfo);
	 }

	 goToRepair(){
     this.currentUser = StorageService.getObj("currentUser");

	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '印章申请办理', url: YZSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair2(){
     this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
      browser: {title: '法人证申请', url: FRZSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair3(){
     this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '校长审签申请', url:XZSQSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair4(){
     this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '宿舍空调申请', url:SSKTSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair5(){
     this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '家属区宽带入网申请', url:JSQKDRWSQ+"?hd="+this.currentUser.hd}});
	 }
	
	 //上拉加载
  loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/myservices/myservices.ts